<div class="modals" [class.main-position-show]="isModalMainPositionShow">
  <a class="close-modal" (click)="closeModal()"></a>

  <h4 class="oferta-text-center">Політика конфіденційності</h4>

  <h4 class="oferta-text-center">1. Загальні положення</h4>

  <p class="indent">
    Згідно Закону України від 01 червня 2010 року № 2297-VI «Про захист персональних даних» (надалі – «Закон») під
    персональними даними
    розуміють відомості чи сукупність відомостей про фізичну особу, яка ідентифікована або може бути конкретно
    ідентифікована.
    Згідно Політики конфіденційності в поняття "особистої інформації" входить інформація, або частина інформації, котра
    дозволяє
    Вас ідентифікувати. Як правило сюди входить ім’я та прізвище, псевдонім (нік), адреса електронної пошти та номер
    телефону,
    адреса розташування, може також входити така інформація, як IP-адреса. Такі відомості ми можемо отримати
    безпосередньо від Вас,
    наприклад, при реєстрації на Інтернет-платформі https://maslotochka.com (надалі – сайт)
    надання контактних даних,
    інформації отриманої із банківської картки або платежів, а також іншу особисту інформацію, яку Ви добровільно надали
    нам.
  </p>
  <p class="indent">
    Компанія з великою повагою ставиться до конфіденційної (персональної) інформації всіх без винятку осіб, які
    відвідали Інтернет - платформу,
    а також тих, хто користується наданими послугами; в зв'язку з чим, Компанія прагне захищати конфіденційність
    персональних даних
    (відомостей чи сукупність відомостей про фізичну особу, яка ідентифікована або може бути конкретно ідентифікована),
    тим самим
    створивши і забезпечивши максимально комфортні умови використання сервісів Інтернет-платформи кожному користувачеві.
  </p>

  <h4 class="oferta-text-center">2. Використання та мета збору персональних даних.</h4>

  <p class="indent">
    Особиста інформація відвідувачів Інтернет-платформи, зібрана при реєстрації, переважно використовується для надання
    послуг у відповідності з
    Вашими потребами, в першу чергу для надання послуг або у договірних відносинах, а також для відповідей на Ваші
    запитання. Також ми можемо використовувати
    Вашу контактну інформацію в поштових відправленнях, а саме повідомляти Вас про нові можливості, акції та інші
    новини. Ми діємо відповідно до цієї
    Політики конфіденційності, на підставі Положення про обробку і захист персональних даних та на підставі чинного
    законодавства України.
  </p>

  <p class="indent">
    Ми маємо право зберігати Персональні дані стільки, скільки необхідно для реалізації мети, що зазначена у даній
    Політиці або у строки,
    встановлені чинним законодавством України або до моменту видалення Вами цих даних.
  </p>

  <h4 class="oferta-text-center">3. Надання доступу до інформації.</h4>

  <p class="indent">
    Надання доступу до особистої інформації іншим компаніям і приватним особам можливе лише за таких наступних обставин:
  </p>

  <ul>
    <li>- Має місце наявність дозволу Користувача. Для передачі будь-якої конфіденційної інформації потрібна згода
      Користувача.
    </li>
    <li>- В випадках визначених чинним законодавством України, а також у випадках запобігання злочину або завдання шкоди
      нам або третім особам.
    </li>
  </ul>

  <h4 class="oferta-text-center">4. Захист інформації.</h4>

  <p class="indent">
    Ми вживаємо всіх необхідних заходів для захисту даних від несанкціонованого доступу, зміни, розкриття чи знищення.
    До цих заходів належать,
    зокрема, внутрішня перевірка процесів збору, зберігання та обробки даних і заходів безпеки, включаючи відповідне
    шифрування і заходи щодо
    забезпечення фізичної безпеки даних для запобігання неавторизованого доступу до систем, в яких ми зберігаємо
    особисті дані.
  </p>

  <h4 class="oferta-text-center">5. Зміна політики конфіденційності.</h4>

  <p class="indent">
    Користувач приймає умови цієї політики конфіденційності і враховує, що дана політика конфіденційності може час від
    часу змінюватися.
    Зміни, що вносяться до політики конфіденційності, публікуються на цій сторінці.
  </p>

  <p class="indent">
    З питань щодо політики конфіденційності (в т.ч. видалення персональних даних), Користувач може зв'язатися з нами
    використовуючи
    засоби зв’язку, що вказані на Інтернет-платформі.
  </p>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
